export default "__VITE_ASSET__D$kmv1ni__"